import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { openLeftBarModule } from "../../modules/actions/layout";
import Fab from "@material-ui/core/Fab";
import Edit from '@material-ui/icons/Edit';

const RailwayRow = ({ railway, openLeftBarModule }) => {
  return (
    <TableRow>
      <TableCell>
        {railway.attributes.name}
      </TableCell>

      <TableCell>
        {railway.attributes['phone-number']}
      </TableCell>

      <TableCell>
        <div onClick={() => openLeftBarModule('railwayAdmin', 'railwayEdit', { id: railway.id })}>
          <Fab color="primary" aria-label="edit" size="small">
            <Edit />
          </Fab>
        </div>
      </TableCell>
    </TableRow>
  );
}

RailwayRow.propTypes = {
  // own props
  railway: PropTypes.shape({
    id: PropTypes.string.isRequired,

    attributes: PropTypes.shape({
      name: PropTypes.string.isRequired,
      'phone-number': PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,

  // dispatch props
  openLeftBarModule: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  openLeftBarModule,
};

export default connect(null, mapDispatchToProps)(RailwayRow);
